exports = module.exports = require("../node_modules/css-loader/lib/css-base.js")(undefined);
// imports
exports.push([module.id, "@import url(https://fonts.googleapis.com/css?family=Hind+Vadodara:300);", ""]);

// module
exports.push([module.id, "@font-face {\n    font-family: 'Aspira-DEMO';\n    font-display: fallback;\n    src: url(" + require("./fonts/Aspira-DEMO-webfont.woff2") + ") format('woff2'), url(" + require("./fonts/Aspira-DEMO-webfont.woff") + ") format('woff');\n    font-weight: normal;\n    font-style: normal;\n}\n\nbody {\n    margin: 0;\n    padding: 0;\n    font-family: 'Hind Vadodara', sans-serif;\n}\n\nh1,\nh2,\nh3,\nh4,\nh5,\nh6 {\n    font-family: 'Aspira-DEMO';\n}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"modules":true,"importLoaders":1,"localIdentName":"[local]___[hash:base64:5]"}!./node_modules/postcss-loader/lib?{"ident":"postcss"}!./src/index.css
// module id = 98
// module chunks = 13